import React, { Component } from "react";
import { connect } from "react-redux";
import * as userActions from "./store/actions";
import { bindActionCreators } from "redux";
import { jwtService } from "services";

class Auth extends Component {
  constructor(props) {
    super(props);
      this.jwtCheck();
  }

  jwtCheck = () => {
    jwtService.on("onAutoLogin", () => {
      console.log("Logging in with JWT");
    });

    /**
     * Sign in and retrieve user data from api
     */
    // jwtService
    //   .signInWithMobile({
    //     UserName: "09398568009",
    //     AppType: "User",
    //   })
    //   .then((user) => {
    //     this.props.setUserData(user);

    //     console.log("Logging in with JWT");
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    jwtService.on("onAutoLogout", (message) => {
      if (message) {
        console.log(message);
      }

      this.props.logout();
    });

    jwtService.init();
  };

  render() {
    const { children } = this.props;

    return <>{children}</>;
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logout: userActions.logoutUser,
      setUserData: userActions.setUserData,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(Auth);
